module.exports = __webpack_public_path__ + "4b399c3d45ea6fda68740d0141881b4c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/up-8.png
// module id = 3081
// module chunks = 0